import React from 'react';
import { LockIcon, ZapIcon } from 'lucide-react';
export function TopBar() {
  return <div className="relative z-40 bg-gold text-ink" data-id="element-476" data-mp="2335avgbd225u">
      <div className="mx-auto flex h-10 max-w-6xl items-center justify-center gap-4 px-5 font-display text-[12px] font-extrabold uppercase tracking-[0.12em] sm:gap-8 sm:text-[13px]" data-id="element-477" data-mp="231c5038knlyw">
        <span className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-478" data-mp="1t60ww3ro5d04">
          <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-479" data-mp="2qszldr87jemx" />
          Compra 100% segura
        </span>
        <span className="h-4 w-px bg-ink/25" aria-hidden="true" data-id="element-480" data-mp="2lt4wft7zsz4i" />
        <span className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-481" data-mp="2h2oj09469di5">
          <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-482" data-mp="2h0txotoznjdj" />
          Acceso inmediato
        </span>
      </div>
    </div>;
}